/* TARAYA header search. Loaded site-wide (the search lives in the header).
   1. Quick links shown before typing.
   2. Ghost completion of the top predictive suggestion (ArrowRight accepts).
   3. Deterministic open/close toggle for the search icon (iOS first-tap fix).
   4. Search closes on a deliberate scroll.
   5. Exit animation hold: close is delayed 175ms so the CSS exit can play.
   Items 3 and 5 patch Origin's details-modal behaviour. After any Origin
   theme update, test: open search by tap and by keyboard, close by Escape,
   by the close button, by clicking outside and by scrolling. */

(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- 1. Quick links ---------- */
  var QUICK_LINKS = [
    ['/collections/silver-idols', 'Silver Idols'],
    ['/collections/auspicious-vahanas', 'Auspicious Vahanas'],
    ['/collections/photo-frames', 'Semi-precious Photo Frames'],
    ['/pages/contact', 'Contact us'],
  ];

  function initQuickLinks() {
    var form = document.querySelector('.search-modal__form form.search');
    if (!form || form.querySelector('.taraya-quicklinks')) return;
    var input = form.querySelector('.search__input');
    var nav = document.createElement('nav');
    nav.className = 'taraya-quicklinks';
    nav.setAttribute('aria-label', 'Quick links');
    var label = document.createElement('p');
    label.className = 'taraya-quicklinks__label';
    label.textContent = 'Quick links';
    var list = document.createElement('ul');
    list.className = 'taraya-quicklinks__list';
    QUICK_LINKS.forEach(function (link) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = link[0];
      a.textContent = link[1];
      li.appendChild(a);
      list.appendChild(li);
    });
    nav.appendChild(label);
    nav.appendChild(list);
    form.appendChild(nav);
    if (input) {
      input.addEventListener('input', function () {
        nav.hidden = input.value.trim().length > 0;
      });
      form.addEventListener('reset', function () {
        setTimeout(function () { nav.hidden = false; }, 0);
      });
    }
  }

  /* ---------- 2. Ghost completion ----------
     Mirrors the top predictive suggestion behind the typed query, reading
     Origin's own results so it needs no extra requests. The ghost is
     aligned to the input's real text box on every update (position, padding
     and font are read from the input), so it cannot drift when the field's
     CSS changes. */
  function initGhost() {
    var form = document.querySelector('.search-modal__form form.search');
    if (!form || form.querySelector('.taraya-ghost')) return;
    var input = form.querySelector('.search__input');
    var results =
      document.querySelector('.search-modal div.predictive-search') ||
      document.querySelector('.search-modal [data-predictive-search]:not(predictive-search)');
    if (!input) return;

    var ghost = document.createElement('span');
    ghost.className = 'taraya-ghost';
    ghost.setAttribute('aria-hidden', 'true');
    var prefix = document.createElement('span');
    prefix.className = 'taraya-ghost__prefix';
    var rest = document.createElement('span');
    rest.className = 'taraya-ghost__rest';
    ghost.appendChild(prefix);
    ghost.appendChild(rest);
    form.appendChild(ghost);
    var completion = '';

    function align() {
      var host = ghost.offsetParent || form;
      var cs = window.getComputedStyle(input);
      var ir = input.getBoundingClientRect();
      var hr = host.getBoundingClientRect();
      ghost.style.left = ir.left - hr.left + parseFloat(cs.paddingLeft) + parseFloat(cs.borderLeftWidth) + 'px';
      ghost.style.right = hr.right - ir.right + parseFloat(cs.paddingRight) + parseFloat(cs.borderRightWidth) + 'px';
      ghost.style.top = ir.top - hr.top + ir.height / 2 + 'px';
      ghost.style.fontFamily = cs.fontFamily;
      ghost.style.fontSize = cs.fontSize;
      ghost.style.fontWeight = cs.fontWeight;
      ghost.style.letterSpacing = cs.letterSpacing;
    }

    function clearGhost() {
      completion = '';
      prefix.textContent = '';
      rest.textContent = '';
    }

    function updateGhost() {
      var q = input.value;
      /* Long queries scroll inside the field; a ghost would misalign. */
      if (!q || !results || input.scrollLeft > 0) return clearGhost();
      var candidates = results.querySelectorAll(
        ".predictive-search__item-heading, .predictive-search__item-query-result, .predictive-search__item [role='option'], .predictive-search__list-item a"
      );
      completion = '';
      for (var i = 0; i < candidates.length; i++) {
        var text = (candidates[i].textContent || '').trim().replace(/\s+/g, ' ');
        if (text && text.toLowerCase().indexOf(q.toLowerCase()) === 0 && text.length > q.length) {
          completion = text;
          break;
        }
      }
      if (!completion) return clearGhost();
      align();
      if (prefix.textContent !== q) prefix.textContent = q;
      var remainder = completion.slice(q.length);
      if (rest.textContent !== remainder) rest.textContent = remainder;
    }

    input.addEventListener('input', function () {
      if (!input.value) clearGhost();
    });
    form.addEventListener('reset', function () {
      setTimeout(clearGhost, 0);
    });
    var modalDetails = form.closest('details');
    if (modalDetails) {
      modalDetails.addEventListener('toggle', function () {
        if (!modalDetails.open) clearGhost();
      });
    }
    window.addEventListener('resize', function () {
      if (completion) align();
    });
    if (results && window.MutationObserver) {
      /* Observe only the results container, never an ancestor of the ghost,
         or the ghost's own updates would re-trigger the observer. */
      new MutationObserver(updateGhost).observe(results, { childList: true, subtree: true });
    }

    /* ArrowRight accepts (caret at end). Tab is never hijacked. */
    input.addEventListener('keydown', function (e) {
      if (!completion) return;
      var atEnd = input.selectionStart === input.value.length;
      if (e.key === 'ArrowRight' && atEnd && input.value.length) {
        input.value = completion;
        clearGhost();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        e.preventDefault();
      }
    });
  }

  /* ---------- 3. Deterministic search toggle ----------
     On iOS the first tap on the search summary was being eaten. pointerup on
     the summary performs the toggle through the element's own open/close
     methods, and the trailing click is suppressed so Origin's handler cannot
     double-toggle. Keyboard activation sends click without pointerup and is
     handled on that branch. */
  function initToggle() {
    var modal = document.querySelector('details-modal.header__search');
    if (!modal || modal.dataset.tarayaToggle) return;
    modal.dataset.tarayaToggle = 'true';

    var details = modal.querySelector('details');
    var summary = modal.querySelector('summary');
    if (!details || !summary) return;

    var handledByPointer = false;

    function toggle() {
      if (details.hasAttribute('open')) {
        if (typeof modal.close === 'function') modal.close();
        else details.removeAttribute('open');
      } else if (typeof modal.open === 'function') {
        modal.open({ target: summary });
      } else {
        details.setAttribute('open', 'true');
      }
    }

    modal.addEventListener(
      'pointerup',
      function (e) {
        if (!summary.contains(e.target)) return;
        if (e.button !== 0) return; /* primary button or touch only */
        handledByPointer = true;
        toggle();
        setTimeout(function () { handledByPointer = false; }, 400);
      },
      true
    );

    modal.addEventListener(
      'click',
      function (e) {
        if (!summary.contains(e.target)) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (!handledByPointer) toggle();
        handledByPointer = false;
      },
      true
    );
  }

  /* ---------- 4. Close on deliberate scroll ----------
     The page stays scrollable behind the open search. Only a wheel or
     touchmove within the last 250ms counts as intent, so iOS scrolling the
     focused input into view does not close it. */
  function initScrollClose() {
    var armedAt = null;
    var intentAt = 0;
    function markIntent() { intentAt = Date.now(); }
    window.addEventListener('wheel', markIntent, { passive: true });
    window.addEventListener('touchmove', markIntent, { passive: true });

    document.addEventListener(
      'scroll',
      function () {
        var open = document.querySelector('.header__search details[open]');
        if (!open) { armedAt = null; return; }
        if (Date.now() - intentAt > 250) return;
        if (armedAt === null) { armedAt = window.scrollY; return; }
        if (Math.abs(window.scrollY - armedAt) > 12) {
          armedAt = null;
          var dm = open.closest('details-modal');
          if (dm && typeof dm.close === 'function') dm.close(false);
          else open.removeAttribute('open');
        }
      },
      { passive: true }
    );
  }

  /* ---------- 5. Exit animation hold ----------
     Origin's close() removes [open] at once, which skips any exit
     transition. For the header search only, close is delayed 175ms (the
     160ms CSS exit plus a frame) behind a closing class. Installed via
     whenDefined so load order does not matter. */
  function installCloseHold(DM) {
    if (!DM || DM.prototype.tarayaWrapped) return;
    DM.prototype.tarayaWrapped = true;
    var orig = DM.prototype.close;
    DM.prototype.close = function (focusToggle) {
      var details = this.querySelector('details');
      var isSearch = this.closest('.header__search');
      if (!isSearch || !details || !details.hasAttribute('open') || details.classList.contains('taraya-search-closing')) {
        return orig.call(this, focusToggle);
      }
      var self = this;
      details.classList.add('taraya-search-closing');
      var ps = details.querySelector('predictive-search');
      var held = ps && ps.hasAttribute('open');
      if (held) ps.setAttribute('data-taraya-hold', '');
      setTimeout(function () {
        details.classList.remove('taraya-search-closing');
        if (held) ps.removeAttribute('data-taraya-hold');
        orig.call(self, focusToggle);
      }, 175);
    };
  }

  if (window.customElements) {
    var existing = customElements.get('details-modal');
    if (existing) installCloseHold(existing);
    else if (customElements.whenDefined) {
      customElements.whenDefined('details-modal').then(function () {
        installCloseHold(customElements.get('details-modal'));
      });
    }
  }

  initScrollClose();
  onReady(function () {
    initQuickLinks();
    initGhost();
    //initToggle();
  });
})();
